import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { JedsMenuService } from "@shared/service/app/jeds-menu.service";
import { SpinnerComponent } from "./spinner/spinner.component";
import { PwaService } from "@shared/service/app/pwa.service";
import { SafeUrlPipe } from "@shared/pipes/safe-url.pipe";
import { DialogGenerarReporteComponent } from "./dialog-generar-reporte/dialog-generar-reporte.component";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { AppAlertService } from "@shared/service/app/alert.service";
import { FuseAlertComponent } from "@fuse/components/alert";
import { ConfigurarGrillaComponent } from "./tabla-dinamica/components/configurar-grilla/configurar-grilla.component";
import { ToggleSwitchComponent } from "./toggle-switch/toggle-switch.component";

@NgModule({
    declarations: [SpinnerComponent, SafeUrlPipe, DialogGenerarReporteComponent, ConfigurarGrillaComponent, ToggleSwitchComponent],
    imports: [
        MatTableModule,
        MatProgressSpinnerModule,
        MatPaginatorModule,
        CommonModule,
        OverlayModule,
        PortalModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatDividerModule,
        MatAutocompleteModule,
        RouterModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        FuseAlertComponent,
        // FuseDrawerModule,
        // FuseScrollbarModule,
        // FuseLoadingBarModule,
        // FuseFullscreenModule,
        // FuseNavigationModule,
        // FuseAlertModule
    ],
    exports: [SpinnerComponent, SafeUrlPipe, ConfigurarGrillaComponent, ToggleSwitchComponent],
    providers: [ JedsMenuService, PwaService, AppAlertService ],
})
export class SharedComponentModule { }